import styled from 'styled-components';
import { comum } from '../../../styles/Themes/light';
import { Badge } from './styles';

export const CloseButtonHeader = styled.div`
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    border-radius: 6px;
    transition: all 0.2s ease;
    flex-shrink: 0;

    &:hover {
        background: ${({ theme }) => theme.colors.interfacePure100};
        transform: scale(1.1);
    }

    &:active {
        transform: scale(0.95);
    }
`;

export const ModalSection = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
    margin-bottom: 0px;
`;

export const Label = styled.label`
    font-size: 12px;
    color: ${({ theme }) => theme.colors.interfaceText300};
    font-weight: 500;
    text-transform: uppercase;
    letter-spacing: 0.5px;

    .asterisco {
        color: ${({ theme }) => theme.colors.primaryRed400};
    }
`;

export const Value = styled.p<{ bold?: boolean }>`
    font-size: 14px;
    color: ${({ theme }) => theme.colors.interfaceText400};
    margin: 0;
    font-weight: ${({ bold }) => bold ? 500 : 400};
`;

export const TextArea = styled.textarea`
    width: 100%;
    min-height: 100px;
    padding: 12px;
    border: 1px solid ${({ theme }) => theme.colors.interfaceText100};
    border-radius: 6px;
    font-size: 14px;
    font-family: inherit;
    color: ${({ theme }) => theme.colors.interfaceText400};
    resize: vertical;
    outline: none;
    transition: border-color 0.2s ease;

    &:focus {
        border-color: ${({ theme }) => theme.colors.primaryRed400};
    }

    &::placeholder {
        color: ${({ theme }) => theme.colors.interfaceText300};
    }
`;

export const ButtonGroup = styled.div`
    display: flex;
    gap: 12px;
    margin-top: 24px;
`;

export const ModalContentWrapper = styled.div`
    display: flex;
    flex-direction: column;
    height: 100%;
    max-height: 70vh;
    overflow: hidden;
`;

export const ModalContentScrollable = styled.div`
    flex: 1;
    overflow-y: auto;
    overflow-x: hidden;
    padding-right: 8px;
    
    &::-webkit-scrollbar {
        width: 8px;
    }
    
    &::-webkit-scrollbar-track {
        background: ${({ theme }) => theme.colors.interfacePure100};
        border-radius: 4px;
    }
    
    &::-webkit-scrollbar-thumb {
        background: ${({ theme }) => theme.colors.interfaceText200};
        border-radius: 4px;
        
        &:hover {
            background: ${({ theme }) => theme.colors.interfaceText300};
        }
    }
`;

export const ModalFooter = styled.div`
    display: flex;
    gap: 12px;
    padding-top: 16px;
    border-top: 1px solid ${({ theme }) => theme.colors.interfacePure100};
    margin-top: 16px;
    flex-shrink: 0;
    background: ${({ theme }) => theme.colors.interfacePure0};
`;

export const Button = styled.button<{ variant?: 'primary' | 'secondary' | 'outline' }>`
    flex: 1;
    padding: 12px 24px;
    border-radius: 6px;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s ease;
    border: 2px solid;
    white-space: nowrap;

    ${({ variant, theme }) => {
        if (variant === 'primary') {
            return `
                background: ${theme.colors.primaryRed400};
                border-color: ${theme.colors.primaryRed400};
                color: ${theme.colors.pureWhite};
                
                &:hover:not(:disabled) {
                    transform: scale(1.02);
                    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.25);
                }
            `;
        } else if (variant === 'outline') {
            return `
                background: ${theme.colors.interfacePure0};
                border-color: ${theme.colors.interfaceText200};
                color: ${theme.colors.interfaceText400};
                
                &:hover:not(:disabled) {
                    background: ${theme.colors.interfacePure100};
                }
            `;
        } else {
            return `
                background: ${theme.colors.interfacePure0};
                border-color: ${theme.colors.interfaceText200};
                color: ${theme.colors.interfaceText400};
                
                &:hover {
                    background: ${theme.colors.interfacePure100};
                }
            `;
        }
    }}

    &:disabled {
        background: ${({theme}) => theme.colors.disabledBg} !important;
        border-color: ${({theme}) => theme.colors.disabledBg} !important;
        color: ${({theme}) => theme.colors.disabledText} !important;
        cursor: not-allowed;
        opacity: 0.6;
    }

    &:active:not(:disabled) {
        transform: translateY(1px);
    }
`;

export const FluxoContainer = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 14px;
`;

export const FluxoBadge = styled(Badge)`
    font-weight: 400;
`;

export const FooterButton = styled.button`
    width: 100%;
    height: 40px;
    padding: 0 1.25rem;
    border: 2px solid ${({ theme }) => theme.colors.primaryRed400};
    border-radius: 6px;
    background: ${({ theme }) => theme.colors.primaryRed400};
    color: ${({ theme }) => theme.colors.pureWhite};
    font-size: 0.875rem;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s ease;
    white-space: nowrap;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
    margin-top: 4px;

    &:hover {
        transform: scale(1.02);
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.25);
    }

    &:active:not(:disabled) {
        transform: translateY(1px);
    }
    
    &:disabled {
        background: ${({theme}) => theme.colors.disabledBg};
        border-color: ${({theme}) => theme.colors.disabledBg};
        color: ${({theme}) => theme.colors.disabledText};
        cursor: not-allowed;
        opacity: 1;
    }
`;

